export default __webpack_public_path__ + "static/thum-video-img03-30eda6af4a7ac19056cc66ad2460b144.jpg";